import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetSubmissionDetailsAsync,
  ISubmissionDetails,
} from "../../api/ISubmission";
import { RootState } from "../store";

export interface SubmissionState {
  fetchStatus: string;
  submission?: ISubmissionDetails;
}

const initialState: SubmissionState = {
  fetchStatus: "Loading...",
  submission: undefined,
};

export const loadSubmissionAsync = createAsyncThunk(
  "submission/load",
  async (submissionId: string) => {
    const response = await GetSubmissionDetailsAsync(submissionId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const submissionSlice = createSlice({
  name: "submission",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadSubmissionAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadSubmissionAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.submission = action.payload;
      });
  },
});

export const selectSubmission = (state: RootState) => state.submission;

export default submissionSlice.reducer;
